import React from 'react';
import { salonInfo } from '../data/mock';
import { useLanguage } from '../i18n/LanguageContext';

export const BookingForm = () => {
  const { t } = useLanguage();
  const openWhatsApp = () => {
    window.open(`https://wa.me/${salonInfo.whatsapp.replace(/\s|\+/g, '')}`, '_blank');
  };

  return (
    <section
      id="booking"
      data-testid="booking-section"
      className="py-24 md:py-32 bg-[#0e0e11] text-neutral-100 relative overflow-hidden"
    >
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#c8b6d9] opacity-[0.03] blur-[140px] pointer-events-none"></div>

      <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-16 relative">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-4 mb-8">
            <span className="divider-line"></span>
            <span className="eyebrow text-lilac">{t.booking.eyebrow}</span>
            <span className="divider-line"></span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-neutral-100 tracking-tight mb-10">
            {t.booking.titleA}
            <span className="block italic text-lilac font-light">{t.booking.titleB}</span>
          </h2>
          <div className="space-y-5 max-w-2xl mx-auto mb-14">
            <p className="text-lg md:text-xl text-neutral-400 leading-relaxed font-light">
              {t.booking.p1}
            </p>
            <p className="text-base md:text-lg text-neutral-500 leading-relaxed font-light">
              {t.booking.p2}
            </p>
          </div>

          <button
            onClick={openWhatsApp}
            data-testid="booking-cta-whatsapp"
            className="group inline-flex items-center gap-5 bg-lilac hover:bg-white text-neutral-950 px-12 py-6 eyebrow transition-all duration-500"
          >
            {t.cta.bookNow}
            <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">→</span>
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/5 border-t border-b border-white/5">
          <div className="bg-[#0e0e11] p-10">
            <p className="eyebrow text-sage mb-5">{t.booking.contact.phone}</p>
            <a
              href={`tel:${salonInfo.phone.replace(/\s/g, '')}`}
              data-testid="contact-phone"
              className="font-display text-xl md:text-2xl text-neutral-100 hover:text-lilac transition-colors block leading-tight"
            >
              {salonInfo.phone}
            </a>
          </div>
          <div className="bg-[#0e0e11] p-10">
            <p className="eyebrow text-sage mb-5">{t.booking.contact.email}</p>
            <a
              href={`mailto:${salonInfo.email}`}
              data-testid="contact-email"
              className="font-display text-xl md:text-2xl text-neutral-100 hover:text-lilac transition-colors block break-all leading-tight"
            >
              {salonInfo.email}
            </a>
          </div>
          <div className="bg-[#0e0e11] p-10">
            <p className="eyebrow text-sage mb-5">{t.booking.contact.studio}</p>
            <p className="font-display text-xl md:text-2xl text-neutral-100 leading-tight">
              {salonInfo.address}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
